import { render, staticRenderFns } from "./userDeletion.vue?vue&type=template&id=6f2927b2"
import script from "./userDeletion.vue?vue&type=script&lang=js"
export * from "./userDeletion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports